import {createApi} from "@reduxjs/toolkit/query/react";
import api from "@/store/api/api";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import {appendFormData} from "@/helpers/form";

export const userApi = createApi({
    reducerPath: 'userApi',
    tagTypes: ['auth'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getAuthUser: build.query({
            providesTags: ['auth'],
            query: (data) => ({
                url: api.user.getAuthUser(),
                method: 'GET',
                params: data
            })
        }),
        editAdminInfo: build.mutation({
            query: ({id, ...data}) => {
                const formData = new FormData();
                appendFormData(formData, data);

                return {
                    url: api.user.editAdminInfo(id),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    },
                    body: formData,
                    formData: true
                };
            },
            invalidatesTags: ['auth']
        }),
        logout: build.mutation({
            providesTags: ['auth'],
            query: () => ({
                url: api.user.logout(),
                method: 'POST'
            })
        }),
        getRoles: build.query({
            providesTags: ['auth'],
            query: (data) => ({
                url: api.user.roles(),
                method: 'GET',
                params: data
            })
        }),
    })
})

export const { useGetAuthUserQuery, useLogoutMutation, useGetRolesQuery } = userApi
